/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { userTypes } from 'constants';
import { Link } from 'react-router-dom';

export const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  text-decoration: none;
  cursor: pointer;
  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  border: 1px transparent solid;

  padding: 8px;
  :hover {
    border-radius: 4px;
    background: ${Palette.Primary._000};
  }
  :active {
    border: 1px solid ${() => Palette.Primary._300};
  }
  cursor: pointer;
  transition: all 0.2s linear;
`;
const highlightStyle = css`
  & strong {
    color: ${Palette.Primary._500};
    font-weight: inherit;
  }
`;

export const Initials = styled.div`
  min-width: 40px;
  min-height: 40px;
  max-width: 40px;
  max-height: 40px;
  border-radius: 50%;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  width: 10%;
  background: ${({ userType }) => getColor(userType)};
`;

export const Box1 = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 67%;
`;

export const Box2 = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
`;

export const Name = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${() => Palette.PrimaryGray._700};
  ${highlightStyle}
`;

export const Email = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${() => Palette.PrimaryGray._400};
  ${highlightStyle}
`;

export const Number = styled.span`
  margin-left: auto;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${() => Palette.PrimaryGray._700};
  ${highlightStyle}
`;

export const Type = styled.span`
  margin-left: auto;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${({ userType }) => getColor(userType)};
  text-transform: capitalize;
`;

const getColor = (status) => {
  if (status === userTypes.advertiser) return Palette.Purple._500;
  if (status === userTypes.publisher) return Palette.Primary._500;
  if (status === userTypes.admin) return Palette.Red._500;
  return Palette.Primary._500;
};
